import {environment} from 'environments/environment';
import {AppComponent} from './app/app.component';
import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from "./app/app.config";
import {registerLocaleData} from "@angular/common";
import 'moment/locale/de';
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe);

const googleMapsParams = {
    apiKey: environment.GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
    language: 'de',
    region: 'DE'
};

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
